import { learnerURLS, URLS } from "@constants/urls";

export const getIsLearnerUrl = (url: string): boolean =>
  learnerURLS.some((pattern) => {
    const regex = new RegExp(`^${pattern.replace(/:\w+/g, "[^/]+")}$`);
    return url.startsWith(pattern) || url.startsWith(`/plus${pattern}`) || regex.test(url);
  });

const redirectURLS = [URLS.user.course, URLS.user.unit];

export const getRedirectionUrl = (defaultUrl: string, url: string): string => {
  for (const pattern of redirectURLS) {
    const regexPattern = pattern.replace(/:\w+/g, "([^/]+)");

    // Make `/plus` optional
    const regex = new RegExp(`^(?:/plus)?${regexPattern}$`);

    const match = url?.match(regex);
    if (match) {
      const courseId = match[1];
      return URLS.courses.getSingleCourse({ courseId });
    }
  }

  return defaultUrl;
};
